export const deviceTypes = {
  computer: 'Desktop',
  tablet: 'Tablet',
  smartphone: 'Mobile',
};
